import { useRipple } from "@songmg/react-use-ripple";
import React, { FC, useRef, useState } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import styled from "styled-components";

interface ButtonWrapperProps {
	isLoading?: boolean;
}

const ButtonWrapper = styled.button<ButtonWrapperProps>`
	display: flex;
	outline: none;
	border: none;
	font-family: Livvic;
	font-style: normal;
	font-weight: bold;
	font-size: 12px;
	line-height: 165.5%;
	cursor: pointer;
	align-items: center;
	text-align: center;
	border-radius: 8px;
	background: ${props => (props.isLoading ? "#cccccc" : props.theme.colors.primary)};
	color: ${props => (props.theme.colors.whiteVitat || "#000000")};
	width: 196px;
	height: 43px;
	justify-content: center;
	gap: 10px;
`;

interface ButtonProps {
	onClick?: any;
	type?: "button" | "submit" | "reset" | undefined;
}

/**
 * Botão padrão, no layout é utilizado como um botão primário.
 *
 * Caso o parâmetro ```onClick``` for ```async``` é executado uma animação durante
 * a execução da função
 */
const Button: FC<ButtonProps> = (props: React.PropsWithChildren<ButtonProps>) => {
	const ref = useRef() as React.MutableRefObject<HTMLButtonElement>;
	useRipple(ref, {
		rippleColor: "#cccccc",
		rippleSize: 300,
		animationLength: 200,
		endScale: 20,
	});
	const [isLoading, setIsLoading] = useState<boolean>(false);

	return (
		<ButtonWrapper
			type={props.type}
			isLoading={isLoading}
			onClick={
				!isLoading
					? async () => {
							if (props.onClick) {
								setIsLoading(true);
								await props.onClick();
								setIsLoading(false);
							}
					  }
					: undefined
			}
			ref={ref}
		>
			{isLoading ? <PulseLoader color={"#FFFFFF"} loading size={8} /> : props.children}
		</ButtonWrapper>
	);
};

export default Button;
